/**
 * 订单表单弹窗各区块共用的标题栏组件
 */

export function SectionHeader({ icon, title, color, hint }: { icon: string; title: string; color: string; hint?: string }) {
  return (
    <div className="flex items-center gap-2.5 pb-3 mb-4 border-b border-gray-100">
      <div className={`w-7 h-7 flex items-center justify-center rounded-lg ${color}`}>
        <i className={`${icon} text-sm`} />
      </div>
      <span className="text-sm font-semibold text-gray-700">{title}</span>
      {hint && (
        <span className="ml-1 flex items-center gap-1 text-xs text-gray-400">
          <div className="w-3.5 h-3.5 flex items-center justify-center shrink-0">
            <i className="ri-information-line text-gray-400" />
          </div>
          {hint}
        </span>
      )}
    </div>
  );
}